import { useCallback, useState } from 'react'

import type { AnswerFilterEntry } from './AnswerFilter'
import type { DateRange } from './Filters'

export interface FilterState {
  selections: Record<string, string[]>
  dateRanges: Record<string, DateRange>
  refinements: Record<string, Record<string, Record<string, string[]>>>
  answerFilters: Record<string, Record<string, AnswerFilterEntry[]>>
  textValues?: Record<string, string>
}

export const emptyFilterState: FilterState = {
  selections: {},
  dateRanges: {},
  refinements: {},
  answerFilters: {},
  textValues: {},
}

export interface UseFilterStateReturn {
  state: FilterState
  setState: React.Dispatch<React.SetStateAction<FilterState>>
  clearCategory: (categoryId: string) => void
  clearAll: () => void
}

export const useFilterState = (initial?: Partial<FilterState>): UseFilterStateReturn => {
  const [state, setState] = useState<FilterState>({ ...emptyFilterState, ...initial })

  const clearCategory = useCallback((categoryId: string) => {
    setState((prev) => {
      const selections = { ...prev.selections }
      delete selections[categoryId]

      const dateRanges = { ...prev.dateRanges }
      delete dateRanges[categoryId]

      const refinements = { ...prev.refinements }
      delete refinements[categoryId]

      const answerFilters = { ...prev.answerFilters }
      delete answerFilters[categoryId]

      const textValues = { ...(prev.textValues ?? {}) }
      delete textValues[categoryId]

      return { selections, dateRanges, refinements, answerFilters, textValues }
    })
  }, [])

  const clearAll = useCallback(() => setState(emptyFilterState), [])

  return { state, setState, clearCategory, clearAll }
}
